export const ITEM_PARAM = 'item'
export const ITEM_CARDS_ID = 'faq-item-cards'
export const ALL_TOPICS_HEADING_ID = 'faq-all-topics-heading'
